import GuideItem from '../GuideItem/GuideItem'
import Product from '../Product/Product'

// const pathname = window.location.pathname

const Collection = ({
    collection,
    productData,
    products,
    numItems,
    guideItem,
}) => {
    // console.log('active, collectionId, products in collection', active, collection.collectionId, products)

    // console.log('collection in collection', collection)

    // console.log(
    //     'products in collection, productData',
    //     collection.collectionTitle,
    //     products,
    //     productData
    // )

    products = products.filter((p) => {
        return p.title.indexOf('hidden') === -1
    })

    return (
        <div className="collection-outer">
            <div className="collection-inner">
                <div className="products">
                    <ul className="nostyle products-list">
                        {products && products.length ? (
                            products.map((p) => {
                                // console.log('p in collection', p)
                                return <Product key={p.id} product={p} />
                            })
                        ) : (
                            <div>Loading...</div>
                        )}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Collection
